module.exports = __webpack_public_path__ + "img/yt_logo_mono_light.7a781beb.png";